import { useState } from "react";
import { copyToClipboard } from "@/utils/clipboard";

const SUPPORT_EMAIL = "soporte@evaluar.com";

export function useSupportEmail() {
  const [isEmailCopied, setIsEmailCopied] = useState(false);

  const handleSupportClick = () => {
    window.open(`mailto:${SUPPORT_EMAIL}`, "_self");
  };

  const handleCopyEmail = async () => {
    const success = await copyToClipboard(SUPPORT_EMAIL);
    if (success) {
      setIsEmailCopied(true);
      setTimeout(() => setIsEmailCopied(false), 2000);
    }
  };

  return {
    supportEmail: SUPPORT_EMAIL,
    isEmailCopied,
    handleSupportClick,
    handleCopyEmail,
  };
}
